import React from 'react';
import PIPComponent from './PIPComponent';

export const PIP = ({ content = null }) => {
  return <PIPComponent content={content} />;
};
